import React from "react";
import { Field } from "redux-form";
import "react-image-crop/dist/ReactCrop.css";

import { Loader, FormField, DisplayField } from "pickups-ui-library";

import { FormGroup, Button, Alert } from "reactstrap";

import {
  phoneNumberValidate,
  requiredValidate,
  emailValidate,
} from "../helpers";
import { formatPhone } from "../../utils/helpers";

const CreateUpdateDonor = (props) => {
  const {
    handleSubmit,
    onSubmit,
    onCancel,
    pristine,
    submitting,
    error,
    submitSucceeded,
  } = props;

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Field
          name="fname"
          type="text"
          component={FormField}
          label="First Name"
          placeholder="First Name"
          required={requiredValidate}
        />
        <Field
          name="lname"
          type="text"
          component={FormField}
          label="Last Name"
          placeholder="Last Name"
          required={requiredValidate}
        />
        <DisplayField label="Login" value={formatPhone(props.phoneNumber)} />
        <Field
          name="email"
          type="text"
          component={FormField}
          label="Email"
          placeholder={process.env.REACT_APP_EMAIL_PLACEHOLDER}
          required={emailValidate}
        />
        <Field
          name="phoneNumbers[0].number"
          type="phone"
          component={FormField}
          label="Primary Phone"
          placeholder=""
          required={[requiredValidate, phoneNumberValidate]}
        />
        <Field
          name="phoneNumbers[1].number"
          type="phone"
          component={FormField}
          label="Secondary Phone"
          placeholder=""
          validate={[phoneNumberValidate]}
        />

        <FormGroup>
          {error && <div className="error">{error}</div>}
          <div className={"pt-2"}>
            {submitSucceeded ? (
              <Alert color="success">Saved Successfully</Alert>
            ) : null}
            <Button type="submit" disabled={pristine || submitting}>
              {submitting ? <Loader /> : "Save"}
            </Button>
          </div>
        </FormGroup>
      </form>
    </>
  );
};

export default CreateUpdateDonor;
